export const WebRoutes = {
    SIGN_IN: "/sign-in",
    SIGN_UP: "/sign-up",
    DASHBOARD: "/dashboard",
    ADMIN: "/admin",
    PROFILE: "/profile",
    USERS: "/users",
    TWO_FACTOR_AUTHENTICATION: "/2fa",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD_NEW: "/reset-password",
    SSO_ERROR_PAGE: "/sso-error/:state",
    HOME_PATH: "/",
    SETPASSWORD: "/set-password",
    LOGIN_REDIRECT: "/:login/redirect",
    FALKON_DOCS: "/falkon-docs",
    FALKON_DOCS_UPLOADS: "/falkon-docs/uploads",
    FALKON_DOCS_UPDATE: "/falkon-docs/update",
    FALKON_DOCS_SUCCESS: "/falkon-docs/success",
    FALKON_DOCS_OTP: "/falkon-docs/otp",
    FALKON_DOCS_VERIFY_OTP: "/falkon-docs/verifyotp",
    FALKON_DOCS_END_USER_SIGN: "/falkon-docs/sign",
    FALKON_DOCS_END_USER_SIGN_SUCCESS: "/falkon-docs/sign/success",
    FALKON_DOCS_COMPLETED: "/falkon-docs/completedDoc",
    SETTINGS: "/settings",
    GENERALSETTINGS: "/settings/general",
    SECURITY: "/settings/security",
    BLOCKED: "/settings/blocked",
    UNSUBSCRIBE: "/settings/unsubscribe",
    SIGNATURE: "/settings/signature",
    LOW_CREDIT_NOTIFICATION: "/settings/low-credit-notification",
    TIMEZONE: "/settings/timezone",
    SCHEDULED_REPORT: "/settings/scheduledreport",
    NOTIFICATION_SETTINGS: "/settings/notification",
    PLANS: "/plans",
    SELECT_PLAN: "/select-plan",
    SYS_ADM_ALL_ORGANIZATIONS:"/sysadmin/organizations",
    SYS_ADM_ALL_USERS:"/sysadmin/users",
    SMS_USER_CALLBACK:"/auth/callback",
    TEMPLATES: "/templates",
    ADD_TEMPLATE: "/templates/add",
}

export const AppRoutes = WebRoutes;